import { get } from 'services/http';

const fetchThemes = kgId => get('/themes');

export default {
  fetchThemes
};
